<template>
  <div>
    <PageAllow
      controller="OrderRulers"
      :action="
        $route.query.mode && $route.query.mode == 'view'
          ? 'combineMaterialView'
          : 'saveCombineMaterial'
      "
    />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{
            $t(isNew ? "CRUD.newInfo" : "CRUD.editInfo", [
              $t("MaterialOrderRule.mixProductRule.title"),
            ])
          }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $permission.checkAccountExpired().then(() => {
                    $router.replace('/material-order-rules?type=' + ruleType);
                  })
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("MaterialOrderRule.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="observer">
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.Fields.rule_name") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('MaterialOrderRule.Fields.rule_name')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="order_rule.name"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'name')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ order_rule.name }}
                </v-col>
              </v-row>
              <!-- 组合商品图片 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.mixProductRule.mix_material_img") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  <v-card v-if="img" max-width="240">
                    <v-img
                      :src="img"
                      @click.stop="$showFullscreenImages([img])"
                    >
                      <v-tooltip right v-if="savable && img">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            color="secondary"
                            class="pa-2 float-right"
                            @click.stop="
                              !img.startsWith('data:image/') &&
                              img == order_rule.img
                                ? (order_rule.img = img = null)
                                : (img = null)
                            "
                          >
                            fa-times
                          </v-icon>
                        </template>
                        <span>
                          {{
                            $t("MaterialOrderRule.mixProductRule.delImg")
                          }}</span
                        >
                      </v-tooltip>
                    </v-img>
                  </v-card>
                  <v-file-input
                    v-if="savable"
                    ref="img_file"
                    show-size
                    prepend-icon="fa-camera"
                    accept="image/png, image/jpeg"
                    persistent-hint
                    :placeholder="$t('Material.imgPlaceholder')"
                    :hint="$t('Material.imgHint')"
                    :rules="imgRules"
                    v-model="img_file"
                  >
                  </v-file-input>
                </v-col>
              </v-row>
              <!-- 优先级数字 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.mixProductRule.priority") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-text-field single-line v-model="order_rule.sort">
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ order_rule.sort }}
                </v-col>
              </v-row>
              <!-- 活动时间 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.mixProductRule.activity_time") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-row>
                    <v-col cols="5" md="4">
                      <!-- <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('MaterialOrderRule.mixProductRule.activity_time')"
                        rules="required"
                      > -->
                      <SearcherDatetime
                        class="my-n2"
                        v-model="order_rule.date_from"
                        type="date"
                        single-line
                        dense
                        hide-details
                        hide-icon
                        disabledBeforeToday
                        readonly
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </SearcherDatetime>
                      <!-- </ValidationProvider> -->
                    </v-col>
                    <v-col cols="1" class="text-center">~</v-col>
                    <v-col cols="5" md="4">
                      <!-- <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('MaterialOrderRule.mixProductRule.activity_time')"
                        rules="required"
                      > -->
                      <SearcherDatetime
                        class="my-n2"
                        v-model="order_rule.date_to"
                        type="date"
                        single-line
                        dense
                        hide-details
                        hide-icon
                        disabledBeforeToday
                        readonly
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </SearcherDatetime>
                      <!-- </ValidationProvider> -->
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ order_rule.date_from | formatDate }}
                  ~
                  {{ order_rule.date_to | formatDate }}
                </v-col>
              </v-row>
              <!-- 单笔最多下单数量 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("MaterialOrderRule.mixProductRule.single_max_num") }}
                  {{ $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-text-field single-line v-model="conditions.max">
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </v-text-field>
                  <!-- </ValidationProvider> -->
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ conditions.max | formatTwoDot }}
                </v-col>
              </v-row>
              <!-- 是否响应要货模板 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.mixProductRule.useTemplate") +
                    $t("Global.colon")
                  }}
                  <!-- <Required :show="savable" :mode="mode" /> -->
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-checkbox
                    v-model="check_template"
                    :hint="$t('MaterialOrderRule.mixProductRule.hint')"
                    true-value="1"
                    false-value="0"
                    persistent-hint
                    small
                  ></v-checkbox>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{
                    check_template == 1
                      ? $t("MaterialOrderRule.mixProductRule.useTemplateOn")
                      : $t("MaterialOrderRule.mixProductRule.useTemplateOff")
                  }}
                </v-col>
              </v-row>
              <!-- 是否首单必定 -->
              <v-row align="center" v-if="check_template == 1">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t(
                      "MaterialOrderRule.mixProductRule.first_order_guarantee"
                    ) + $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-checkbox
                    v-model="first_order_guarantee"
                    :true-value="1"
                    :false-value="0"
                    persistent-hint
                    :hint="
                      $t(
                        'MaterialOrderRule.mixProductRule.firstOrderGuaranteeHint'
                      )
                    "
                    small
                  ></v-checkbox>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{
                    first_order_guarantee == 1
                      ? $t("MaterialOrderRule.mixProductRule.useTemplateOn")
                      : $t("MaterialOrderRule.mixProductRule.useTemplateOff")
                  }}
                </v-col>
              </v-row>

              <!-- 组合商品分账接口 -->
              <v-row
                align="center"
                v-if="settings && settings.sub_account_enable"
              >
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("MaterialOrderRule.Fields.sub_account_pay_type")
                  }}{{ $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-select
                    v-model="conditions.sub_account_pay_type"
                    :items="bankSelect"
                    item-value="value"
                    item-text="text"
                  ></v-select>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{
                    bankSelect.find(
                      (b) => b.value == conditions.sub_account_pay_type
                    )
                      ? bankSelect.find(
                          (b) => b.value == conditions.sub_account_pay_type
                        ).text
                      : ""
                  }}
                </v-col>
              </v-row>
              <!-- 要货商品 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("MaterialOrderRule.Fields.material_name")
                  }}{{ $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                  <br />
                  <v-btn
                    v-if="savable"
                    color="primary"
                    class="my-1 mr-3"
                    x-small
                    outlined
                    @click="materials_dialog = true"
                  >
                    {{
                      $t("CRUD.chooseInfo", [
                        $t("MaterialOrderRule.Fields.material"),
                      ])
                    }}
                  </v-btn>
                </v-col>
                <v-col cols="9" md="7">
                  <v-card-text>
                    <v-row>
                      <span class="font-weight-bold me-2">
                        {{ $t("MaterialOrderRule.mixProductRule.group_money")
                        }}{{ $t("Global.colon") }}
                      </span>
                      <span v-if="follow_template">-</span>
                      <span v-else>
                        {{ $t("Global.money") }}
                        {{ price | formatMoneyFloor }}
                      </span>
                    </v-row>
                  </v-card-text>
                  <v-data-table
                    :headers="materialHeaders"
                    :items="materialItems"
                    :loading="materialsLoading"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                    fixed-header
                  >
                    <template v-slot:item.Description="{ item }">
                      <span>{{ item.material_name }}</span>
                      <br />
                      <span class="caption secondary--text">
                        {{ $t("Material.Fields.standard")
                        }}{{ $t("Global.colon") }}
                        <span
                          v-if="
                            item.standard_name && item.standard_name.length > 12
                          "
                          :title="item.standard_name"
                          style="cursor: pointer"
                        >
                          {{ item.standard_name.slice(0, 12) + "......" }}
                        </span>
                        <span v-else>
                          {{ item.standard_name }}
                        </span>
                      </span>
                    </template>
                    <template v-slot:header.price="{ header }">
                      <v-row align="center" v-if="savable">
                        <v-col cols="3">
                          {{ header.text }}
                        </v-col>
                        <v-col cols="9">
                          <v-select
                            single-line
                            dense
                            hide-details
                            style="width: 100px"
                            class="caption grey--text"
                            :items="priceTypesSelect"
                            item-text="text"
                            item-value="value"
                            v-model="follow_template"
                          />
                        </v-col>
                      </v-row>
                      <span v-else>
                        {{ header.text }}
                      </span>
                    </template>
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>
                    <template v-slot:item.num="{ item }">
                      <NumberInput v-if="savable" v-model="item.num" dense />
                      <span v-else>{{ item.num }}</span>
                    </template>
                    <template v-slot:item.price="{ item }">
                      <span v-if="follow_template">
                        <a
                          class="text-no-wrap"
                          @click.stop="
                            templatePriceDetailsDialog = true;
                            currentItem = item;
                          "
                          >{{
                            $t("MaterialOrderRule.Fields.follow_template")
                          }}</a
                        >
                      </span>
                      <span v-else>
                        <v-text-field
                          v-if="savable"
                          v-model="item.price"
                          single-line
                          dense
                          hide-details
                          type="number"
                          min="0"
                          :prefix="$t('Global.money')"
                          style="max-width: 80px; margin-left: auto"
                          @blur="
                            item.price = $numberFormatter.formatMoney(
                              item.price
                            )
                          "
                        />
                        <span v-else>
                          {{ $t("Global.money") }}{{ item.price }}
                        </span>
                      </span>
                    </template>
                    <template v-slot:item.split_price="{ item }">
                      <v-btn
                        v-if="settings && settings.sub_account_enable"
                        small
                        text
                        color="info"
                        @click="splitPriceItem = item"
                      >
                        {{ $t("Opt.details") }}
                      </v-btn>
                    </template>
                    <template v-slot:item.service_charge_percent="{ item }">
                      <v-text-field
                        v-if="savable"
                        single-line
                        dense
                        hide-details
                        v-model="item.service_charge_percent"
                        type="number"
                        min="0"
                        suffix="%"
                        @blur="
                          item.service_charge_percent =
                            $numberFormatter.formatWithDotNoMoreThan(
                              item.service_charge_percent,
                              2
                            )
                        "
                        style="max-width: 100px; margin-left: auto"
                      />
                      <span v-else> {{ item.service_charge_percent }} % </span>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <!-- 删除商品按钮 -->
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          materials.splice(
                            materials.findIndex(
                              (material) => material.id == item.id
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <!-- 分组 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.Fields.application_districts") +
                    $t("Global.colon")
                  }}
                  <br />
                  <span v-if="savable">
                    <v-btn
                      color="primary"
                      class="my-1 mr-3"
                      x-small
                      outlined
                      @click="districts_dialog = true"
                    >
                      {{
                        $t("CRUD.chooseInfo", [
                          $t("MaterialOrderRule.Fields.application_districts"),
                        ])
                      }}
                    </v-btn>
                    <br />
                    <span class="text-caption">
                      {{ $t("MaterialOrderRule.Fields.districts_hint") }}
                    </span>
                  </span>

                  <!-- 适用组别 -->
                </v-col>
                <v-col cols="9" md="7">
                  <v-data-table
                    :headers="districtHeaders"
                    :items="districts"
                    :loading="districtsLoading"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                    fixed-header
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          districts.splice(
                            districts.findIndex(
                              (district) => district.id == item.id
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  @click="
                    $permission.checkAccountExpired().then(() => {
                      $router.replace('/material-order-rules?type=' + ruleType);
                    })
                  "
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{
                    $t("CRUD.backToList", [$t("MaterialOrderRule.ObjectName")])
                  }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  isView &&
                  $permission.permissionAllow(
                    'OrderRulers',
                    'saveCombineMaterial'
                  )
                "
              >
                <v-btn
                  color="accent"
                  block
                  :disabled="loading && !order_rule.id"
                  @click="toEdit = true"
                >
                  <v-icon small class="pe-1">fa-pencil-alt</v-icon>
                  {{
                    $t("CRUD.editInfo", [$t("MaterialOrderRule.ObjectName")])
                  }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  savable &&
                  $permission.permissionAllow(
                    'OrderRulers',
                    'saveCombineMaterial'
                  )
                "
              >
                <v-btn
                  color="success"
                  block
                  :disabled="loading && !order_rule.id"
                  @click="submit()"
                >
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{
                    $t("CRUD.saveInfo", [$t("MaterialOrderRule.ObjectName")])
                  }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
        <v-card class="mt-4" v-if="!isNew">
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-row dense align="center">
                  <span class="text-button">{{
                    $t("MaterialOrderRule.Fields.status")
                  }}</span>
                  <v-spacer></v-spacer>
                  <v-chip small label color="gray" text-color="black"
                    >{{ order_rule.status | orderRuleStatusText }}
                  </v-chip>
                </v-row>
              </v-col>
              <!-- <v-col cols="12">
                <v-btn color="primary" class="elevation-1 my-1" block>
                  <span class="mx-2">
                    {{ order_rule.status | orderRuleStatusText }}
                  </span>
                </v-btn>
              </v-col> -->
              <v-col
                cols="12"
                v-if="
                  savable &&
                  $permission.permissionAllow('OrderRulers', 'updateStatus')
                "
              >
                <v-btn
                  v-if="order_rule.status"
                  outlined
                  color="primary"
                  class="elevation-1"
                  block
                  :disabled="loading && !order_rule.id"
                  @click="changeStatus()"
                >
                  {{ $t("MaterialOrderRule.Fields.stop_use") }}
                </v-btn>
                <v-btn
                  v-else
                  outlined
                  color="primary"
                  class="elevation-1"
                  block
                  :disabled="loading && !order_rule.id"
                  @click="useRuleDialog = true"
                >
                  {{ $t("MaterialOrderRule.Fields.start_use") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
      <MaterialsSelectsDialog
        v-model="materials_dialog"
        :materialIds="materialIds"
        @confirm="choosedMaterials = $event"
      />
      <DialogDistricts
        v-model="districts_dialog"
        :districtSelected="districts"
        @confirm="districts = $event"
      />
      <DialogAlert
        v-model="useRuleDialog"
        :message="$t('MaterialOrderRule.Messages.useRule')"
        useConfirm
        persistent
        @confirm="changeStatus(true)"
      />
      <DialogAlert
        v-model="isLeaveDialog"
        :message="alertMessage"
        persistent
        useConfirm
        @confirm="confirmLeave = true"
      />
    </v-sheet>
    <SplitPrice
      v-model="splitPriceItem"
      :mode="mode"
      :bank_code="conditions.sub_account_pay_type"
      :price="splitPriceItem ? Number(splitPriceItem.price) : 0"
      percent
    />
    <TemplatePriceSetting
      v-model="templatePriceDetailsDialog"
      :material="currentItem"
    />
  </div>
</template>
<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Required from "@/components/plugins/Required";
import DialogDistricts from "@/components/plugins/DialogDistricts";
import MaterialsSelectsDialog from "@/components/plugins/MaterialsSelectsDialog";
import DialogAlert from "@/components/plugins/DialogAlert";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import OrderRules from "@/api/order_rules";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import Files from "@/api/files";
import NumberInput from "@/components/plugins/NumberInput";
import SubAccounts from "@/api/sub_accounts";
import SplitPrice from "../templates/plugins/SplitPrice";
import Materials from "@/api/materials";
import TemplatePriceSetting from "./plugins/TemplatePriceSetting";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    Required,
    MaterialsSelectsDialog,
    DialogDistricts,
    DialogAlert,
    SearcherDatetime,
    ValidationObserver,
    ValidationProvider,
    NumberInput,
    SplitPrice,
    TemplatePriceSetting,
  },

  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.materialManagement"),
          disabled: false,
          href: "/materials",
        },
        {
          text: i18n.t("Nav.materialOrderRules"),
          disabled: true,
          href: "/material-order-rules",
        },
      ];
    },
    isNew() {
      return this.mode == "new";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isView() {
      return this.mode == "view";
    },
    ruleType() {
      return this.$route.query.type;
    },

    materialHeaders() {
      var materialHeaders = [];
      materialHeaders.push({
        text: i18n.t("MaterialOrderRule.Fields.material_code"),
        align: "start",
        sortable: false,
        value: "material_code",
      });
      materialHeaders.push({
        text: i18n.t("MaterialOrderRule.Fields.material_name"),
        align: "start",
        sortable: false,
        value: "Description",
      });

      materialHeaders.push(
        {
          text: i18n.t("MaterialOrderRule.Fields.num"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "num",
        },
        {
          text: i18n.t("MaterialOrderRule.Fields.price"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "price",
        }
      );
      if (
        this.settings &&
        this.settings.sub_account_enable &&
        this.settings.sub_account_enable != 2 &&
        !this.follow_template
      ) {
        materialHeaders.push({
          text: i18n.t("MaterialOrderRule.Fields.split_price"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "split_price",
        });
      }
      if (this.settings && this.settings.service_charge_enable) {
        materialHeaders.push({
          text: i18n.t("MaterialOrderRule.Fields.service_charge_percent"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "service_charge_percent",
        });
      }

      if (this.savable) {
        materialHeaders.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }

      return materialHeaders;
    },
    districtHeaders() {
      var headers = [
        {
          text: i18n.t("MaterialOrderRule.Fields.district_code"),
          align: "start",
          sortable: false,
          value: "number",
        },
        {
          text: i18n.t("MaterialOrderRule.Fields.district_name"),
          align: "start",
          sortable: false,
          value: "name",
        },
      ];
      if (this.savable) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }
      return headers;
    },
    materialItems() {
      return this.materials.map((detail) => {
        detail.Description = i18n.t(
          this.settings
            ? this.settings.material_name_display_type == 4
              ? "Material.nameWithCodeAndStandard"
              : this.settings.material_name_display_type == 3
              ? "Material.materialNameWithCodeAndStandard"
              : this.settings.material_name_display_type == 2
              ? "Material.materialNameWithCode"
              : "Material.materialName"
            : "Material.materialName",
          [detail.material_code, detail.material_name, detail.standard_name]
        );
        return detail;
      });
    },
    priceTypesSelect: () => [
      { value: 0, text: i18n.t("MaterialOrderRule.Fields.custom") },
      { value: 1, text: i18n.t("MaterialOrderRule.Fields.follow_template") },
    ],
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    img: "",
    img_file: null,
    price: 0, //组合金额
    mode: "",
    choosedMaterials: [], //每次选中的商品
    order_rule: {},
    conditions: { max: 1 },
    serverErrors: [],
    materials_dialog: false,
    materials: [],
    materialIds: [],
    materialsLoading: false,
    districts_dialog: false,
    districts: [],
    districtsLoading: false,
    useRuleDialog: false,
    submit_data: {},
    imgRules: [
      (value) => !value || value.size < 5000000 || i18n.t("Material.imgHint"),
    ],
    bankSelect: [],
    splitPriceItem: null,
    isLeave: false,
    isLeaveDialog: false,
    alertMessage: "",
    confirmLeave: false,
    toPage: "",
    toEdit: false,
    first_order_guarantee: 1,
    follow_template: 0,
    templatePriceDetailsDialog: false,
    currentItem: {},
    check_template: 0,
  }),

  mounted() {
    if (this.$route.params.id == 0) {
      this.mode = "new";
    } else {
      this.mode = this.$route.query.mode ? this.$route.query.mode : "view";
      this.getOrderRuleFromAPI(this.$route.params.id);
    }

    // 获取分账接口备选项
    SubAccounts.fetchBankSelect().then(
      function (response) {
        if (response.data.status.isOK()) {
          this.bankSelect = Object.keys(response.data.banks).map((key) => {
            return {
              text: response.data.banks[key],
              value: key,
            };
          });
        }
      }.bind(this)
    );
  },

  methods: {
    getOrderRuleFromAPI(id) {
      OrderRules.fetchOne(id, { type: this.ruleType }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.order_rule = response.data.order_ruler;
            this.img = this.order_rule.img;
            this.conditions = response.data.order_ruler.conditions;
            this.first_order_guarantee =
              response.data.order_ruler.conditions.check_template == 0
                ? 1
                : response.data.order_ruler.conditions.first_order_guarantee;
            this.follow_template = response.data.order_ruler.conditions
              .follow_template
              ? response.data.order_ruler.conditions.follow_template
              : 0;
            this.check_template = response.data.order_ruler.conditions
              .check_template
              ? response.data.order_ruler.conditions.check_template
              : 0;

            if (response.data.order_ruler.conditions.material_ids) {
              var materials = [];
              response.data.order_ruler.conditions.material_ids.forEach(
                (item) => {
                  var material =
                    response.data.order_ruler.conditions.materials.find(
                      (detail) => detail.id == item.material_id
                    );
                  materials.push(Object.assign({}, material, item));
                }
              );
              this.materials = materials;
            }
            this.districts =
              response.data.order_ruler.districts &&
              response.data.order_ruler.districts.length
                ? response.data.order_ruler.districts
                : [];
          }
        }.bind(this)
      );
    },
    submit() {
      this.$store.dispatch("fullscreenLoading");
      this.serverErrors = []; //重置远端错误提示
      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            if (this.img_file) {
              let response = await Files.imageQacenterUpload(
                this.img_file,
                true
              );
              if (response.data.status.isOK()) {
                this.order_rule.img = response.data.data.img_name;
                this.order_rule.thumbnail = response.data.data.thumbnail;
              }
            }
            if (
              (!this.order_rule.date_from || !this.order_rule.date_to) &&
              this.ruleType == 6
            ) {
              this.$store.dispatch("fullscreenLoadingStop");
              this.$snackbar.error(
                i18n.t("MaterialOrderRule.Messages.dateNull")
              );
            } else {
              var date_from1 = new Date(
                this.order_rule.date_from.replace(/-/g, "/")
              );
              var date_to1 = new Date(
                this.order_rule.date_to.replace(/-/g, "/")
              );
              if (date_from1 > date_to1) {
                this.$store.dispatch("fullscreenLoadingStop");
                this.$snackbar.error(
                  i18n.t("MaterialOrderRule.Messages.dateCompare")
                );
              } else if (!this.img) {
                this.$store.dispatch("fullscreenLoadingStop");
                this.$snackbar.error(
                  i18n.t("MaterialOrderRule.Messages.imgNull")
                );
              } else if (!this.materials.length) {
                this.$store.dispatch("fullscreenLoadingStop");
                this.$snackbar.error(
                  i18n.t("MaterialOrderRule.Messages.materialsNull")
                );
              } else {
                let district_ids = [];
                if (this.districts.length) {
                  district_ids = this.districts.map((district) => {
                    return district.id;
                  });
                }

                let material_ids = [];
                if (this.materials.length) {
                  material_ids = this.materials.map((material) => {
                    var data = {
                      material_id: material.id,
                      num: material.num ? material.num : 0,
                      price: material.price ? material.price : 0,
                      sub_account_price_json: material.sub_account_price_json
                        ? material.sub_account_price_json
                        : null,
                    };
                    if (this.settings && this.settings.service_charge_enable) {
                      data = Object.assign({}, data, {
                        service_charge_percent: material.service_charge_percent,
                      });
                    }
                    return data;
                  });
                }

                this.submit_data = Object.assign({}, this.submit_data, {
                  max: this.conditions.max, //单笔最多下单数量
                  price: this.price, //组合金额
                  sort: this.order_rule.sort, //优先级数字
                  check_template: this.check_template, //是否响应要货模板
                  district_ids: district_ids, //适用组别
                  material_ids: material_ids, //要货商品
                  sub_account_pay_type: this.conditions.sub_account_pay_type, //分账接口
                  date_from: this.order_rule.date_from, //活动开始时间
                  date_to: this.order_rule.date_to, //活动结束时间
                  img: this.order_rule.img, //组合商品图片
                  first_order_guarantee:
                    this.check_template == 0 ? 0 : this.first_order_guarantee,
                  follow_template: this.follow_template,
                });

                if (this.mode == "edit" || this.order_rule.id) {
                  this.submit_data = Object.assign({}, this.submit_data, {
                    id: this.order_rule.id
                      ? this.order_rule.id
                      : this.$route.params.id,
                  });
                }

                OrderRules.save(
                  this.ruleType,
                  Object.assign({}, this.submit_data, {
                    name: this.order_rule.name,
                  })
                ).then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.order_rule = response.data.order_ruler;
                      // this.$router.replace("/material-order-rules?type=6");
                      this.$snackbar.success(
                        i18n.t("MaterialOrderRule.Messages.saveSuccess")
                      );
                      if (!this.order_rule.status) {
                        this.useRuleDialog = true;
                      }
                      if (this.isNew) {
                        this.mode = "edit";
                      }
                    } else if (
                      response.data.error &&
                      response.data.error.data &&
                      "ERR333" == response.data.error.code
                    ) {
                      this.serverErrors = response.data.error.data;
                    }
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                );
              }
            }
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    changeStatus(backToList) {
      OrderRules.changeStatus(this.order_rule.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (backToList) {
              this.confirmLeave = true;
              this.$router.replace(
                "/material-order-rules?type=" + this.ruleType
              );
            } else {
              this.getOrderRuleFromAPI(this.order_rule.id);
            }
          }
        }.bind(this)
      );
    },
  },

  watch: {
    materials: {
      deep: true,
      handler() {
        if (this.materials.length) {
          var price = 0;
          this.materials.forEach((element) => {
            price += parseFloat(
              this.$numberFormatter.formatMoneyFloor(
                Number(element.num) * Number(element.price)
              )
            );
          });
          price = parseFloat(price.toFixed(2));
          this.price = price;

          this.materialIds = this.materials.map((material) => {
            return material.id;
          });
        } else {
          this.price = 0;
          this.materialIds = [];
        }
      },
    },
    // 监听单次选择的商品
    choosedMaterials: {
      handler() {
        //  综合多次选择的商品
        var ids = [];
        ids = this.choosedMaterials.map((material) => {
          return material.id;
        });
        console.log(ids);
        Materials.fetchNoCancel({
          material_ids: ids,
        }).then(
          function (response) {
            if (response.data.status.isOK()) {
              response.data.materials.forEach((material) => {
                this.materials.push(
                  Object.assign({}, material, {
                    price: 0,
                    service_charge_percent: 0,
                  })
                );
              });
            }
          }.bind(this)
        );
      },
    },
    // 监听缩略图的改变
    img: {
      handler() {
        if (!this.img) {
          this.img_file = null;
        }
      },
    },
    // 监听图片文件的改变
    img_file: {
      handler() {
        if (this.img_file) {
          var reader = new FileReader();
          reader.readAsDataURL(this.img_file);
          let that = this;
          reader.onload = function () {
            that.img = this.result;
          };
        } else {
          this.img = this.order_rule.img;
        }
      },
    },
    confirmLeave: {
      deep: true,
      handler() {
        if (this.confirmLeave) {
          if (this.toPage.path.startsWith("/material-order-rules")) {
            this.$router.replace("/material-order-rules?type=" + this.ruleType);
          } else {
            this.$router.replace(this.toPage.path);
          }
        }
      },
    },
    toEdit: {
      handler() {
        if (this.toEdit) {
          this.$router.replace({
            path: this.$route.path,
            query: { type: this.order_rule.type, mode: "edit" },
          });
          this.mode = "edit";
        }
      },
    },
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    if (!this.order_rule.status && !this.isNew) {
      this.toPage = to;
      if (this.confirmLeave) {
        next();
      } else if (!this.toEdit) {
        this.isLeaveDialog = true;
        this.alertMessage = i18n.t(
          "MaterialOrderRule.Messages.isLeaveALertMsg"
        );
        next(false);
      } else {
        next();
      }
    } else {
      next();
    }
  },
};
</script>